import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable @faire/prefer-arrow-methods */
import { diag } from "@opentelemetry/api";
import { hrTime } from "@opentelemetry/core";
import { InstrumentationBase } from "@opentelemetry/instrumentation";
var PACKAGE_VERSION = "faire-0.1";
var PACKAGE_NAME = "LongRunningTask";
export var LONGTASK_PERFORMANCE_TYPE = "LongTask";
export var LongTaskInstrumentation = /*#__PURE__*/function (_InstrumentationBase) {
  function LongTaskInstrumentation() {
    var _this;
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, LongTaskInstrumentation);
    _this = _callSuper(this, LongTaskInstrumentation, [PACKAGE_NAME, PACKAGE_VERSION, config]);
    _this.version = PACKAGE_VERSION;
    _this._createSpanFromEntry = function (entry) {
      var _this$getConfig = _this.getConfig(),
        observerCallback = _this$getConfig.observerCallback,
        onCreateSpan = _this$getConfig.onCreateSpan;
      var span;
      if (onCreateSpan) {
        span = onCreateSpan(hrTime(entry.startTime));
      }
      if (!span) {
        span = _this.tracer.startSpan(LONGTASK_PERFORMANCE_TYPE, {
          startTime: hrTime(entry.startTime)
        });
      }
      if (observerCallback) {
        try {
          observerCallback(span, {
            longtaskEntry: entry
          });
        } catch (err) {
          diag.error("longtask instrumentation: observer callback failed", err);
        }
      }
      span.setAttribute("longtask.name", entry.name);
      span.setAttribute("longtask.entry_type", entry.entryType);
      span.setAttribute("longtask.duration", entry.duration);
      if (Array.isArray(entry.attribution)) {
        entry.attribution.forEach(function (attribution, index) {
          var _span, _span2, _span3, _span4, _span5, _span6, _span7, _span8;
          var prefix = entry.attribution.length > 1 ? "longtask.attribution[".concat(index, "]") : "longtask.attribution";
          (_span = span) === null || _span === void 0 ? void 0 : _span.setAttribute("".concat(prefix, ".name"), attribution.name);
          (_span2 = span) === null || _span2 === void 0 ? void 0 : _span2.setAttribute("".concat(prefix, ".entry_type"), attribution.entryType);
          (_span3 = span) === null || _span3 === void 0 ? void 0 : _span3.setAttribute("".concat(prefix, ".start_time"), attribution.startTime);
          (_span4 = span) === null || _span4 === void 0 ? void 0 : _span4.setAttribute("".concat(prefix, ".duration"), attribution.duration);
          (_span5 = span) === null || _span5 === void 0 ? void 0 : _span5.setAttribute("".concat(prefix, ".container_type"), attribution.containerType);
          (_span6 = span) === null || _span6 === void 0 ? void 0 : _span6.setAttribute("".concat(prefix, ".container_src"), attribution.containerSrc);
          (_span7 = span) === null || _span7 === void 0 ? void 0 : _span7.setAttribute("".concat(prefix, ".container_id"), attribution.containerId);
          (_span8 = span) === null || _span8 === void 0 ? void 0 : _span8.setAttribute("".concat(prefix, ".container_name"), attribution.containerName);
        });
      }
      span.end(hrTime(entry.startTime + entry.duration));
    };
    return _this;
  }
  _inherits(LongTaskInstrumentation, _InstrumentationBase);
  return _createClass(LongTaskInstrumentation, [{
    key: "init",
    value: function init() {}
  }, {
    key: "isSupported",
    value: function isSupported() {
      if (typeof PerformanceObserver === "undefined" || !PerformanceObserver.supportedEntryTypes) {
        return false;
      }
      return PerformanceObserver.supportedEntryTypes.includes(LONGTASK_PERFORMANCE_TYPE);
    }
  }, {
    key: "enable",
    value: function enable() {
      var _this2 = this;
      if (!this.isSupported()) {
        this._diag.debug("Environment not supported");
        return;
      }
      if (this._observer) {
        // Already enabled
        return;
      }
      this._observer = new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          return _this2._createSpanFromEntry(entry);
        });
      });
      this._observer.observe({
        type: LONGTASK_PERFORMANCE_TYPE,
        buffered: true
      });
    }
  }, {
    key: "disable",
    value: function disable() {
      if (!this._observer) {
        return;
      }
      this._observer.disconnect();
      this._observer = undefined;
    }
  }]);
}(InstrumentationBase);